import axios from 'axios'
import store from '../store'
import bus from './bus'
import { APPKEY, ENV } from '../config'
import { getToken } from './token'
import { md5Http, collectApiMap } from './common'
import router from '@/layout/router'
const HomeModuleId = '2820215716730110'

// 判断是否是用户主动打开页签
const userOpenModule = (tag) => {
  const reloadRoutes = window.__ERP_reloadRoutes || {}
  return !reloadRoutes[tag]
}

/**
 * 处理长任务数据格式化
 * @param {object} taskInfo
 */
export function formatLongTaskData(taskInfo) {
  const longTaskData = taskInfo && taskInfo.toJSON()
  if (longTaskData) {
    longTaskData.scripts = Array.isArray(taskInfo.scripts) && taskInfo.scripts.map(i => i.toJSON && i.toJSON()).filter(Boolean)
  }
  return longTaskData
}

class LogPlugin {
  constructor () {
    let conf = window.__ERPGLOABLECONFIG__ || {}
    this.xhrList = []
    this.maxLongTaskList = 15
    this.longTaskList = []
    this.domEvent = '登录erp'
    this.lastPushTag = ''
    this.lastPushUrl = ''
    this.countThreshold = 5
    this.timeThreshold = conf.logTimeThreshold || 10
    this.maxRequestCount = 20
    this.markBackgroundTimestamp = null // 标记切入后台
    this.markForegroundTimestamp = null // 标记切入前台
    this.isWebviewActive = true // webview是否活跃在前台
    this.eventIdMap = {}
    this.addEventListener()
    window.setInterval(this.checkList.bind(this), this.timeThreshold * 1000)
    bus.$once('APP_LOADED', this.firstReport.bind(this))
    window.__ERP_LASTTAG__ = this.randomCode()
    this.getObserver(this.handleLongTask.bind(this))
  }

  firstReport() {
    window.setTimeout(_ => {
      this.handleMenuOpen({tag: 'home', menuId: HomeModuleId, title: '首页', time: Date.now()})
    }, 3000)
  }

  getNormalizer () {
    return {
      xpath: '',
      action: '',
      userId: '',
      menuId: '',
      startTime: '',
      endTime: '',
      url: '',
      requestHeaders: '',
      requestBody: '',
      responseHeaders: '',
      responseData: '',
      httpStatus: '',
      webTraceId: '',
      resCode: ''
    }
  }

  checkList () {
    if (this.xhrList.length && this.xhrList.some(item => item.immediate)) {
      console.log('[log-plugin] 立即上报')
      this.upload()
      this.clearList()
    }
    if (this.xhrList.length >= this.countThreshold) {
      console.log('[log-plugin] 达到采集量上报')
      this.upload()
      this.clearList()
    }
    if (!this.xhrList.length) return
    if ((+new Date() - this.xhrList[0].config.startTime) / 1000 > this.timeThreshold) {
      console.log(`[log-plugin] 超时上报: ${this.timeThreshold} 秒`)
      this.upload()
      this.clearList()
    }
  }

  clearList () {
    this.xhrList = []
    window.requestIdleCallback(this.clearResourceTimings)
  }

  upload () {
    let userId = window.__ERPUSER__ ? window.__ERPUSER__.id : ''
    if (!userId) {
      console.info('[log-plugin] 未获取到用户id')
      // return
    }
    let logs = store.state.tagsView.logs
    let ua = navigator.appVersion || navigator.userAgent
    let data = this.handleWebviewHideXhrData(this.xhrList).map(item => {
      let config = item.config
      let menuId = config.headers['X-menu-id']
      let obj = this.getNormalizer()
      const net = window.navigator.connection || {}
      const { performanceStartTime, performanceEndTime } = config

      obj.userId = userId || localStorage.ERPCacheFlag || 'xxxx'
      obj.menuId = menuId
      obj.location = config.location || ''
      obj.navigator = ua
      obj.xpath = config.actionTag || ''
      obj.action = config.actionDom || ''
      obj.subAction = config.subActionDom || ''
      obj.startTime = String(config.startTime || 0)
      obj.endTime = String(config.endTime || 0)
      obj.url = config.url || ''
      obj.httpStatus = String(item.status || '')
      obj.webTraceId = config.headers['x-webtrace-id']
      obj.timing = config.timing

      const currentMemory = this.getMemoryInfo()
      obj.networkInformation = { downlink: net.downlink, rtt: net.rtt, performanceStartTime, performanceEndTime, memory: JSON.stringify(currentMemory) }
      obj.networkInformation.extend = `${config.performanceStartTimeOrigin} - ${config.performanceEndTimeOrigin}  urlHash: ${location.hash}`

      const requestTimeout = 3000
      if ((Number(config.endTime) - Number(config.startTime)) > requestTimeout) {
        this.longTaskList.length = this.maxLongTaskList // 兜底, 防溢出
        obj.networkInformation.longTask = JSON.stringify(this.longTaskList.filter(Boolean))
      }

      if (logs[menuId]) {
        obj.requestHeaders = `${userId}-${menuId}-${logs[menuId]}`
      }
      if (item.data && item.data.code !== undefined) {
        obj.resCode = String(item.data.code)
      }
      return obj
    })
    let token = getToken()
    let now = Date.now()
    const BaseUrl = collectApiMap[ENV] || collectApiMap['uat']
    axios({
      method: 'post',
      url: `${BaseUrl}?cts.trace.uploadWebActionLog`,
      data,
      headers: {
        format: 'JSON',
        method: 'cts.trace.uploadWebActionLog',
        appkey: APPKEY['cts'],
        token,
        timestamp: now,
        sign: md5Http(token, now, data),
        'X-Env': ENV || 'uat'
      }
    })
  }

  handleConfig (config) {
    config.startTime = Math.floor(performance.timeOrigin + performance.now())
    config.performanceStartTimeOrigin = performance.timeOrigin
    config.performanceStartTime = performance.now()
    config.actionDom = this.domEvent
    config.subActionDom = window.__ERP_LASTSUBEVENT__
    config.actionTag = window.__ERP_LASTTAG__
    config.location = location.href
    this.recordEventId(window.__ERP_LASTTAG__)
    if (typeof config.data === 'object') {
      let data = config.data
      if (data['ERPSearchPreload'] || data['ERPDisabledLog']) {
        config.headers['disabled-log'] = true
      }
    }
  }

  push (xhr) {
    let conf = xhr.config
    // 过滤掉不走开放平台的接口
    if (!conf.headers || !conf.headers.method) {
      return
    }
    // 过滤掉标注为不上报日志的接口
    if (conf.headers && conf.headers['disabled-log']) {
      return
    }
    if (conf.$config && conf.$config.log === false) {
      return
    }

    // 过滤掉webview不在前台的数据日志
    if (this.isWebviewActive === false) return

    if (conf.actionDom && conf.actionTag && !this.isRepeatedUrl(conf.actionTag, conf.headers.method)) {
      this.lastPushTag = conf.actionTag
      this.lastPushUrl = conf.headers.method
      // xhr = JSON.parse(JSON.stringify(xhr))
      xhr.config.endTime = Math.floor(performance.timeOrigin + performance.now())
      xhr.config.performanceEndTimeOrigin = performance.timeOrigin
      xhr.config.performanceEndTime = performance.now()
      xhr.config.timing = this.getPerformanceByUrl(conf.url)
      this.xhrList.push(xhr)
      // 异步队列
      setTimeout(this.checkList.bind(this))
    }
  }

  recordEventId(eventId) {
    if (!eventId) return
    this.eventIdMap[eventId] = this.eventIdMap[eventId] ? this.eventIdMap[eventId] + 1 : 1
    if (this.eventIdMap[eventId] > this.maxRequestCount) {
      window.__ERP_LASTTAG__ = this.randomCode()
    }
  }

  isRepeatedUrl (tag, url) {
    return this.lastPushTag === tag && this.lastPushUrl === url
  }

  randomCode () {
    this.eventIdMap = {}
    const id = (window.__ERPUSER__ && window.__ERPUSER__.id) || ''
    return id + Date.now() + Math.floor(10000 + 10000 * Math.random())
  }

  hasLoadingMask (path) {
    return path.some(v => v.className && typeof v.className === 'string' && v.className.includes('el-loading-mask'))
  }

  isInvalidDom (dom) {
    let name = dom.className
    return typeof name === 'string' ? name.includes('el-dialog__wrapper') || name.includes('main-panel') || name.includes('log-disabled') : true
  }

  handleRouterChange () {
    // this.domEvent = '进入页面'
    window.__ERP_LASTTAG__ = this.randomCode()
    window.__ERP_LASTSUBEVENT__ = ''
  }

  getEventName (target) {
    if (!target) return ''
    const classList = target.classList
    if (target.tagName === 'CANVAS') {
      return '点击表格'
    }
    if (classList.contains('kye-header')) {
      return '点击页面头部'
    }
    if (classList.contains('layout-yemianfanhui')) {
      return '点击返回'
    }
    if (target.localName === 'kye-menu') {
      return '点击左侧菜单'
    }
    if (target.localName === 'input') {
      return 'input ' + target.placeholder
    }
    return target.textContent || target.className || ' '
  }

  handleEvent (e) {
    let eventName
    try {
      eventName = this.getEventName(e.target)
    } catch (_) {
      eventName = '未知'
    }
    window.__ERP_LASTEVENT__ = this.domEvent = eventName ? eventName.trim().replace(/\s/g, '').substr(0, 15) : eventName
    window.__ERP_LASTTAG__ = this.randomCode()
  }

  handleMenuOpen ({ tag, menuId, title, time }) {
    if (!userOpenModule(tag)) {
      return
    }
    let userId = window.__ERPUSER__ ? window.__ERPUSER__.id : (localStorage.ERPCacheFlag || 'xxxx')
    let code = Math.floor(1000 + 1000 * Math.random())
    let startTime = (store.state.tagsView && store.state.tagsView.logs[menuId]) || time
    let obj = {
      status: '200',
      data: {
        code: '0'
      },
      config: {
        url: tag,
        location: tag,
        actionTag: `${userId}${time}${code}`,
        actionDom: '进入模块:' + title,
        startTime: time,
        endTime: '0',
        headers: {
          'X-menu-id': menuId,
          webTraceId: `${userId}-${menuId}-${startTime}-${window.__ERP_LASTTAG__}-${code}`,
          'x-webtrace-id': `${userId}-${menuId}-${startTime}-${window.__ERP_LASTTAG__}-${code}`
        }
      }
    }
    obj.immediate = true
    this.xhrList.push(obj)
    // 异步队列
    setTimeout(this.checkList.bind(this), 20)
  }

  clearResourceTimings () {
    const maxResourceCount = 100
    const resource = performance.getEntriesByType('resource')
    if (resource && resource.length && resource.length > maxResourceCount) {
      performance.clearResourceTimings()
    }
  }

  getPerformanceByUrl (url) {
    if (!window.performance) return ''
    const performanceResourceTimings = performance.getEntriesByType('resource')
    const timing = performanceResourceTimings.filter(p => p.name.indexOf(url) >= 0)
    if (timing.length && timing[0].toJSON) {
      return {...timing[0].toJSON(), timeOrigin: performance.timeOrigin}
    }
    return ''
  }

  getObserver (cb) {
    const type = 'long-animation-frame'
    const perfObserver = new PerformanceObserver((entryList) => {
      cb(entryList.getEntries())
    })
    perfObserver.observe({type})
  }

  handleLongTask (taskList) {
    taskList.forEach(task => {
      if (task.blockingDuration > 100) {
        if (this.longTaskList.length > this.maxLongTaskList) {
          this.longTaskList.shift()
        }
        const longTaskData = formatLongTaskData(task)
        this.longTaskList.push(longTaskData)
      }
    })
  }

  getMemoryInfo() {
    const m = performance ? performance.memory : null
    if (!m) return null
    return {jsHeapSizeLimit: m.jsHeapSizeLimit, totalJSHeapSize: m.totalJSHeapSize, usedJSHeapSize: m.usedJSHeapSize}
  }

  // 处理在webview在后台场景，解决浏览器降频和线程挂起，导致数据采集异常问题
  handleWebviewHideXhrData(xhrList = []) {
    try {
      const { markBackgroundTimestamp, markForegroundTimestamp } = this
      const newXhrList = xhrList.filter(item => {
        const { config } = item
        const startTime = config.startTime
        // 只上报大于切入后台和前台时间节点的请求
        const isUpload = startTime > markBackgroundTimestamp && startTime > markForegroundTimestamp
        if (!isUpload) console.log('过滤掉异常数据上报')
        return isUpload
      })
      return newXhrList
    } catch (e) {
      console.error('err-handleWebviewHideXhrData', e)
      return xhrList
    }
  }

  addEventListener () {
    document.addEventListener('mousedown', this.handleEvent.bind(this), true)
    document.addEventListener('keydown', this.handleEvent.bind(this), true)
    router.afterEach(this.handleRouterChange.bind(this))
    document.addEventListener('visibilitychange', () => {
      this.handleRouterChange()
      // 标记是否挂后台
      const isShow = document.visibilityState === 'visible'
      const keyName = isShow ? 'markForegroundTimestamp' : 'markBackgroundTimestamp'
      this[keyName] = Date.now()
      this.isWebviewActive = isShow
    })
    bus.$on('GLOBAL_MENU_OPEN', this.handleMenuOpen.bind(this))
  }

  makeActionId() {
    return this.randomCode()
  }

  // 自定义日志事件名称
  click (option = {}) {
    if (typeof option === 'string') {
      this.domEvent = option
      return
    }
    if (option.actionName) {
      this.domEvent = option.actionName
    }
    if (option.actionId) {
      window.__ERP_LASTTAG__ = option.lastTag
    }
  }
}


let _logPlugin

if (window.__ERP_PUBLIC_SHARED_LOG__) {
  _logPlugin = window.__ERP_PUBLIC_SHARED_LOG__
} else {
  window.__ERP_PUBLIC_SHARED_LOG__ = _logPlugin = new LogPlugin()
}

export default _logPlugin



// WEBPACK FOOTER //
// ./src/public/utils/log-plugin.js